import { getToken } from "../../../../context/auth";

const getBaseUrl = () => process.env.REACT_APP_BASE_URL || "https://alarabeyya.com/api";

export const fetchRelativeLessonsDetails = async (relativeLessons) => {
  const token = getToken();
  const baseUrl = getBaseUrl();
  const response = await fetch(`${baseUrl}/ContentInfo`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(relativeLessons),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const resData = await response.json();
  return resData.data || [];
};

export const fetchDbQuestions = async (dbQuestionItems) => {
  const token = getToken();
  const baseUrl = getBaseUrl();
  const response = await fetch(`${baseUrl}/QuestionsLookups`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(dbQuestionItems),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const resData = await response.json();
  return resData.data || [];
};

export const fetchSuggestions = async () => {
  const token = getToken();
  const baseUrl = getBaseUrl();
  const response = await fetch(`${baseUrl}/chat/suggestions`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const resData = await response.json();
  return resData.data || [];
};
